import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SessionTimerService } from 'src/app/_service/session-timer.service';
import { SessionData, SessionService } from 'src/app/_service/session.service';

@Component({
  selector: 'app-session-timer',
  templateUrl: './session-timer.component.html',
  styleUrls: ['./session-timer.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SessionTimerComponent {
  
  @Input() timerType: string;
  
  simpleSessionRemainingTime = this.sessionTimerService.simpleSessionRemainingTime$ ?? "expired";
  remainingTime = this.sessionTimerService.remainingTime$ ?? "expired";

  constructor(
    private sessionTimerService: SessionTimerService,
    private sessionService: SessionService
  ) {
  }

  initTimer(uuid: string): void {
    this.sessionService.getSessionData(uuid).subscribe(
      {
        next: response => {
          const sessionData = new SessionData();
          sessionData.returnUrl = response.returnUrl;
          sessionData.time = response.time;
          sessionData.uuid = response.uuid;
          this.sessionTimerService.initializeTimer(sessionData);
        },
        error: (e) => {
          console.error(e);
        }
      });
  }

  initSimpleTimer(sessionTimeSeconds: number): void {
    this.sessionTimerService.initializeSimpleTimer(sessionTimeSeconds);
  }
}